module.exports = __webpack_public_path__ + "static/img/6051_phase_function_Paper_PointsHejduk_Prediction.34726e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6051_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Ge9V
// module chunks = 0